export const defaultState = {
  referenceNumber: null,
  invoiceDate: null,
  invoicePayedDate: null,
  vatId: null,
  visibility: null,
  memberAssociation: null,
  clientMemberAssociation: null,
  dateFrom: null,
  dateTo: null,
};

const UPDATE_FIELD = 'UPDATE_FIELD';

export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === UPDATE_FIELD) {
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
